import { render } from "./operate-editor.vue?vue&type=template&id=7f7fbf77&scoped=true&ts=true"
import script from "./operate-editor.vue?vue&type=script&lang=ts"
export * from "./operate-editor.vue?vue&type=script&lang=ts"

import "./operate-editor.vue?vue&type=style&index=0&id=7f7fbf77&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7fbf77"]])

export default __exports__